(function () {
    'use strict';
    angular.module('doclr.monkeypoxsubscription', ['ngAnimate']);
})();
